import { render, staticRenderFns } from "./statusChip.vue?vue&type=template&id=22d4ce78&"
import script from "./statusChip.vue?vue&type=script&lang=js&"
export * from "./statusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports